<template>
  <v-dialog v-model="dialog" persistent :max-width="650">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="warning"
        style="margin-top: 15px"
        dark
        block
        v-bind="attrs"
        v-on="on"
      >
        Generar Gasto
      </v-btn>
    </template>
    <v-card :loading="loading">
      <v-card-title class="text-h6"> Nuevo Gasto </v-card-title>
      <div class="centered-table">
        <v-progress-circular
          v-if="mostrarLoading"
          indeterminate
          color="primary"
          size="50"
        ></v-progress-circular>
        <div v-else>
          <v-simple-table class="my-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <v-icon small class="mr-2" color="grey darken-2"
                      >mdi-format-list-bulleted</v-icon
                    >
                    Concepto
                  </th>
                  <th class="text-center">
                    <v-icon small class="mr-2" color="grey darken-2"
                      >mdi-currency-usd</v-icon
                    >
                    Neto
                  </th>
                  <th class="text-center">
                    <v-icon small class="mr-2" color="grey darken-2"
                      >mdi-percent</v-icon
                    >
                    IVA
                  </th>
                  <th class="text-center">
                    <v-icon small class="mr-2" color="grey darken-2"
                      >mdi-calculator</v-icon
                    >
                    Total
                  </th>
                  <th class="text-center">
                    <v-icon small color="grey darken-2">mdi-cog</v-icon>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(gasto, index) in gastos"
                  :key="index"
                  v-if="gasto.administrativos.administrativo > 0"
                >
                  <td class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-2"
                      >mdi-account-tie</v-icon
                    >
                    <span class="font-weight-medium">Honorarios MFSA</span>
                  </td>

                  <td class="text-center font-weight-medium">
                    {{
                      formatCurrency(
                        gasto.administrativos.administrativo.toFixed(2)
                      )
                    }}
                  </td>
                  <td class="text-center">
                    {{ formatCurrency(gasto.administrativos.iva.toFixed(2)) }}
                  </td>
                  <td class="text-center font-weight-medium">
                    {{
                      formatCurrency(
                        (
                          gasto.administrativos.administrativo +
                          gasto.administrativos.iva
                        ).toFixed(2)
                      )
                    }}
                  </td>
                  <td class="text-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="red"
                          v-bind="attrs"
                          v-on="on"
                          @click="eliminarGasto(gasto.idGasto)"
                          class="hover-elevate"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar gasto</span>
                    </v-tooltip>
                  </td>
                </tr>
                <!-- Gastos de escribanos -->
                <tr
                  v-for="(gasto, index) in gastos"
                  :key="index"
                  v-if="gasto.administrativos.otorgamiento > 0"
                >
                  <td class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-2"
                      >mdi-file-document-edit</v-icon
                    >
                    <span class="font-weight-medium">Gastos de Escribano</span>
                  </td>

                  <td class="text-center font-weight-medium">
                    {{
                      formatCurrency(
                        gasto.administrativos.otorgamiento.toFixed(2)
                      )
                    }}
                  </td>
                  <td class="text-center">
                    {{ formatCurrency(gasto.administrativos.iva.toFixed(2)) }}
                  </td>
                  <td class="text-center font-weight-medium">
                    {{
                      formatCurrency(
                        (
                          gasto.administrativos.otorgamiento +
                          gasto.administrativos.iva
                        ).toFixed(2)
                      )
                    }}
                  </td>
                  <td class="text-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="red"
                          v-bind="attrs"
                          v-on="on"
                          @click="eliminarGasto(gasto.idGasto)"
                          class="hover-elevate"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar gasto</span>
                    </v-tooltip>
                  </td>
                </tr>

                <!-- Gastos de IIBB -->
                <tr
                  v-for="(gasto, index) in gastos"
                  :key="index + '_iibb'"
                  v-if="gasto.iibb > 0"
                >
                  <td class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-2"
                      >mdi-bank</v-icon
                    >
                    <span class="font-weight-medium">IIBB</span>
                  </td>
                  <td class="text-center font-weight-medium">
                    {{ formatCurrency(gasto.iibb.toFixed(2)) }}
                  </td>
                  <td class="text-center">$0,00</td>
                  <td class="text-center font-weight-medium">
                    {{ formatCurrency(gasto.iibb.toFixed(2)) }}
                  </td>
                  <td class="text-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="red"
                          v-bind="attrs"
                          v-on="on"
                          @click="eliminarGasto(gasto.idGasto)"
                          class="hover-elevate"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar gasto</span>
                    </v-tooltip>
                  </td>
                </tr>

                <!-- Totales -->
                <tr class="totals-row">
                  <td class="d-flex align-center">
                    <v-icon small color="grey darken-2" class="mr-2"
                      >mdi-calculator-variant</v-icon
                    >
                    <span class="font-weight-bold text-h6">Totales</span>
                  </td>
                  <td class="text-center">
                    <span
                      class="font-weight-bold text-h6 grey--text text--darken-3"
                      >{{ formatCurrency(totalNeto.toFixed(2)) }}</span
                    >
                  </td>
                  <td class="text-center">
                    <span
                      class="font-weight-bold text-h6 grey--text text--darken-3"
                      >{{ formatCurrency(totalIva.toFixed(2)) }}</span
                    >
                  </td>
                  <td class="text-center">
                    <span
                      class="font-weight-bold text-h6 grey--text text--darken-4"
                      >{{ formatCurrency(totalGeneral.toFixed(2)) }}</span
                    >
                  </td>
                  <td class="text-center"></td>
                </tr>
              </tbody>
            </template>
            <!-- Cerrar aquí -->
          </v-simple-table>
        </div>
      </div>
      <v-card-text>
        <v-row>
          <v-col :lg="iva_flag ? 6 : 12">
            <v-text-field
              label="Monto"
              @keyup="calcularIVA"
              v-model="montoFormatted"
              @input="handleMonto"
              @blur="formatMonto"
              @keypress="onlyNumbers"
              @paste="onPaste"
            >
            </v-text-field>
          </v-col>
          <v-col lg="6" v-if="iva_flag">
            <v-text-field
              label="IVA"
              v-model="ivaFormatted"
              @input="handleIva"
              @blur="formatIva"
              @keypress="onlyNumbers"
              @paste="onPaste"
              style="-moz-appearance: textfield"
              class="no-spin"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-col>
          <v-btn-toggle v-model="tipo_gasto" borderless color="primary">
            <v-btn value="otorgamiento">
              <span class="hidden-sm-and-down">Otorgamiento</span>
            </v-btn>
            <v-btn value="administrativo">
              <span class="hidden-sm-and-down">Administrativos</span>
            </v-btn>
            <v-btn value="iibb">
              <span class="hidden-sm-and-down">IIBB</span>
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col>
          <v-btn-toggle
            v-if="tipo_gasto !== 'iibb'"
            v-model="iva_flag"
            borderless
            color="green"
          >
            <v-btn :value="false">
              <span class="hidden-sm-and-down">s/IVA</span>
            </v-btn>
            <v-btn :value="true" @click="calcularIVA">
              <span class="hidden-sm-and-down">c/IVA</span>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          :disabled="monto <= 0 || tipo_gasto === ''"
          @click="guardarGasto"
        >
          Cargar
        </v-btn>
        <v-btn color="red darken-1" text @click="cerrarModal"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { API_URL } from '@/common/config';
import axios from 'axios';

export default {
  name: 'ModalGastos',
  props: ['lineacreditocliente_id', 'idDesembolso', 'anr'],
  data: () => ({
    tipo_gasto: '',
    monto: 0,
    iva: 0,

    total: 0,
    totalGastos: 0,
    honorariosMfs: 0,
    honorariosMfsIva: 0,
    iibbHonorariosMfs: 0,
    totalHonorariosMfs: 0,

    otrosGastos: 0,
    totalOtrosGastos: 0,
    ivaOtrosGastos: 0,
    iibbOtrosGastos: 0,

    totalNeto: 0,
    totalIva: 0,
    totalIibb: 0,
    totalGeneral: 0,

    loading: false,
    iva_flag: false,
    dialog: false,
    gastos: [],
    mostrarLoading: false,
    header: {
      headers: {
        token: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
    },
    formatter: new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
    }),
  }),
  computed: {
    montoFormatted: {
      get() {
        return this.formatCurrency(this.monto);
      },
      set(value) {
        const valueAsString = String(value || '');
        const cleanValue = valueAsString.replace(/[$,.]/g, ''); // Eliminar $ y .
        const numericValue = parseFloat(cleanValue) / 100; // Dividir por 100

        // Validar que el valor sea un número válido
        if (isNaN(numericValue)) {
          this.monto = 0; // Establecer como 0 si no es válido
        } else {
          this.monto = numericValue; // Guardar el valor numérico
        }
      },
    },
    ivaFormatted: {
      get() {
        return this.formatCurrency(this.iva);
      },
      set(value) {
        const valueAsString = String(value || '');
        const cleanValue = valueAsString.replace(/[$,.]/g, ''); // Eliminar $ y .
        const numericValue = parseFloat(cleanValue) / 100; // Dividir por 100

        // Validar que el valor sea un número válido
        if (isNaN(numericValue)) {
          this.iva = 0; // Establecer como 0 si no es válido
        } else {
          this.iva = numericValue; // Guardar el valor numérico
        }
      },
    },
  },
  methods: {
    async eliminarGasto(idGasto) {
      if (!idGasto) {
        return;
      }
      this.$swal({
        title: '¿Esta seguro?',
        text: 'Esta acción elimina el gasto',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, Cancelar',
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.mostrarLoading = true;
          const url = `${API_URL}api/v1/gastos/${idGasto}`;
          const header = {
            headers: {
              token: this.token,
            },
          };

          axios
            .delete(url, header)
            .then(async (response) => {
              if (response.data.status === 'success') {
                await this.$swal.fire({
                  icon: 'info',
                  title: 'Desembolso Eliminado',
                  showConfirmButton: false,
                  timer: 1500,
                });

                this.getGastos();
              }
              this.mostrarLoading = false;
            })

            .catch((error) => {
              console.log(error);
              this.mostrarLoading = false;
            });
        }
      });
    },
    formatMonto() {
      const numericValue = parseFloat(this.monto);
      if (!isNaN(numericValue)) {
        this.monto = numericValue;
      }
    },
    // Formato de moneda
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') return '';
      return this.formatter.format(parseFloat(value));
    },

    // Manejar la entrada de Monto
    handleMonto(value) {
      this.montoFormatted = value; // Llamar al setter de montoFormatted
    },

    // Manejar la entrada de IVA
    handleIva(value) {
      this.ivaFormatted = value; // Llamar al setter de ivaFormatted
    },

    formatIva() {
      const numericValue = parseFloat(this.iva);
      if (!isNaN(numericValue)) {
        this.iva = numericValue;
      }
    },

    calcularTotales() {
      // Resetear todos los totales
      this.totalNeto = 0;
      this.totalIva = 0;
      this.totalIibb = 0;
      this.totalGeneral = 0;

      // Variables auxiliares
      let netoAdministrativos = 0;
      let ivaAdministrativos = 0;
      let netoOtorgamiento = 0;
      let ivaOtorgamiento = 0;
      let totalIibb = 0;

      this.gastos.forEach((gasto) => {
        // Honorarios MFSA (Administrativos)
        if (gasto.administrativos.administrativo > 0) {
          netoAdministrativos += parseFloat(
            gasto.administrativos.administrativo || 0
          );
          ivaAdministrativos += parseFloat(gasto.administrativos.iva || 0);
        }

        // Gastos de Escribano (Otorgamiento)
        if (gasto.administrativos.otorgamiento > 0) {
          netoOtorgamiento += parseFloat(
            gasto.administrativos.otorgamiento || 0
          );
          ivaOtorgamiento += parseFloat(gasto.administrativos.iva || 0);
        }

        // IIBB
        if (gasto.iibb > 0) {
          totalIibb += parseFloat(gasto.iibb || 0);
        }
      });

      // Calcular totales finales
      this.totalNeto = netoAdministrativos + netoOtorgamiento + totalIibb;
      this.totalIva = ivaAdministrativos + ivaOtorgamiento;
      this.totalGeneral = this.totalNeto + this.totalIva;
    },
    async cerrarModal() {
      this.dialog = false;
    },
    calcularIVA() {
      this.iva = parseFloat(this.monto * 0.21).toFixed(2);
    },
    async guardarGasto() {
      this.loading = true;
      //const url = `${API_URL}api/gastos/generar`;
      const url = `${API_URL}api/v1/gastos`;
      if (this.tipo_gasto === '') {
        return;
      }

      const data = {
        lineacreditocliente_id: this.lineacreditocliente_id,
        otorgamiento: '0',
        posteriores: '0',
        iva: '0',
        iibb: '0',
        desembolso_id: this.idDesembolso ? this.idDesembolso : '0',
      };
      data[this.tipo_gasto] = parseFloat(this.monto).toFixed(2).toString();

      if (this.iva_flag) {
        data.iva = parseFloat(this.iva).toFixed(2).toString();
      }

      await axios
        .post(url, data, this.header)
        .then((result) => {
          this.loading = false;
          this.$swal({
            title: 'Gasto nuevo',
            text: 'El gasto se generó con exito',
            type: 'success',
            timer: 2000, // Set timer to 2 seconds (2000 milliseconds)
          });

          this.getGastos();
          this.monto = '0';
          this.iva = '0';
          this.iva_flag = false;
          this.$emit('creditoLiquidado');
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
          this.$swal({
            title: 'Gasto nuevo',
            text: 'Ocurrió un error al generar el gasto',
            type: 'error',
            timer: 2000,
          });
          // this.$router.go(0);
        });
    },
    onlyNumbers(event) {
      const char = String.fromCharCode(event.which);
      if (
        !/[0-9.,]/.test(char) &&
        event.keyCode !== 8 &&
        event.keyCode !== 46
      ) {
        event.preventDefault();
      }
    },
    onPaste(event) {
      const paste = (event.clipboardData || window.clipboardData).getData(
        'text'
      );
      if (!/^[0-9.,]*$/.test(paste)) {
        event.preventDefault();
      }
    },
    async getGastos() {
      try {
        this.mostrarLoading = true;
        const desembolsoId = this.anr ? this.idDesembolso || '0' : '0';
        const legajo = this.lineacreditocliente_id.toString();
        const query = {
          method: 'get',
          // url: `${API_URL}api/gastos/cc`,
          url: `${API_URL}api/v1/gastos/legajo/${legajo}/desembolso/${desembolsoId}`,
          headers: {
            token: this.token,
          },
        };
        const {
          data: { status, response },
        } = await axios(query);

        if (status === 'success') {
          this.gastos = response;
          this.calcularTotales();
        }
        this.mostrarLoading = false;
        if (status === 'error') {
          console.log(`Error ${message} statusCode: ${statusCode}`);
        }
      } catch (error) {
        console.error(error);
        this.mostrarLoading = false;
      }
    },
  },
  watch: {
    reRender(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.calcularTotales();
      }
    },
  },
  created() {
    this.getGastos();
  },
};
</script>

<style scoped>
.my-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.my-table thead th {
  background-color: #f5f5f5;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.my-table tbody tr {
  transition: background-color 0.2s ease;
}

.my-table tbody tr:hover {
  background-color: #f8f9fa;
}

.totals-row {
  background-color: #f0f8ff !important;
  border-top: 2px solid #2196f3;
}

.totals-row:hover {
  background-color: #e3f2fd !important;
}

.hover-elevate {
  transition: all 0.2s ease;
}

.hover-elevate:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.centered-table {
  padding: 16px;
}

/* Remove increment/decrement buttons from number inputs */
.no-spin >>> input[type='number']::-webkit-outer-spin-button,
.no-spin >>> input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spin >>> input[type='number'] {
  -moz-appearance: textfield;
}
</style>
